import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Button, Tooltip, Typography } from "antd";
import classname from "classname";

import { AvatarEmployee, Table } from "components/UI";
import { FaRegTrashAlt } from "react-icons/fa";

const DetailSelectedTable = ({
  data,
  disabled,
  loading,
  titleColumn,
  onDelete,
}) => {
  const { t } = useTranslation();

  const columnsTable = useMemo(() => {
    const columns = [];
    columns.push({
      title: titleColumn ? titleColumn : t("employee.employee_name"),
      dataIndex: "label",
      key: "label",
      sorter: false,
      fixed: "left",
      render: (value, row, index) => {
        return (
          <div className="flex flex-row items-center space-x-2 w-full">
            <AvatarEmployee
              index={index}
              name={value}
              avatarURL={row?.hr_avatar_url || row?.hr_employee?.hr_avatar_url}
            />
            <div className="flex flex-wrap">
              <Typography.Text
                className={classname("text-gray-900 dark:text-white")}
              >
                {value || ""}
              </Typography.Text>
            </div>
          </div>
        );
      },
    });
    if (!disabled) {
      columns.push({
        title: t("attendanceApproval.action"),
        dataIndex: "is_deletable",
        key: "action",
        sorter: false,
        width: 100,
        align: "center",
        render: (value, row) => {
          return (
            <div>
              <Tooltip title={t("button.delete")} trigger={["hover"]}>
                <Button
                  className={`flex float-right hover:opacity-70`}
                  id="btn-delete"
                  type="primary"
                  icon={<FaRegTrashAlt />}
                  onClick={() => onDelete(row)}
                  disabled={!row?.value}
                />
              </Tooltip>
            </div>
          );
        },
      });
    }
    return columns;
  }, [t, disabled, titleColumn, onDelete]);

  return (
    <div>
      <Table
        loading={loading}
        columns={columnsTable}
        dataSource={data || []}
        pagination={false}
        withNumbering={false}
        rowKey="value"
        scroll={{
          y: 300,
        }}
        isFloatingHeader
      />
    </div>
  );
};

export default DetailSelectedTable;
